/*
 * <nc-look-badge> — the count of the header "Tu look" control (Phase A1, Javi 2026-10-23: Normcore does not sell).
 * Shows the number of garments in the person's current look. Reads only through NcApp.gateway().getMyLook() (the persisted look of the
 * user; in A1 the mock's per-user localStorage record, Phase B swaps the adapter). Updates live on `nc-fitting:added` (a garment was
 * added), `nc-fitting:change` (the fitting room changed the look), `nc-look:change` (the Tu look page removed or restored one) and on
 * the `storage` event of other tabs. Without a gateway it keeps the server-rendered 0. No network of its own.
 * data-one / data-other carry the screen-reader sentence with the {count} placeholder (from locales).
 */
(function () {
  // generation state of the header control (probador unificado, step 3): 'generating' while a look is being created, 'ready' right after it
  // finishes (the person may have closed the sheet), else 'idle'. generating = nc-looks:change detail.generating
  function badgeState(prev, now) {
    if (now > 0) return 'generating';
    return prev > 0 ? 'ready' : 'idle';
  }
  var READY_MS = 8000;

  if (typeof module !== 'undefined' && module.exports) { module.exports = { badgeState: badgeState }; return; }
  if (typeof customElements === 'undefined' || customElements.get('nc-look-badge')) return;

  function fill(pattern, n) { return String(pattern || '').replace('{count}', String(n)); }

  class NcLookBadge extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.refresh = this.refresh.bind(this);
      document.addEventListener('nc-fitting:added', this.refresh);
      document.addEventListener('nc-fitting:change', this.refresh);
      document.addEventListener('nc-look:change', this.refresh);
      window.addEventListener('storage', this.refresh);
      var self = this;
      this.generating = 0;
      this.onLooks = function (e) { self.setGenerating((e.detail && e.detail.generating) || 0); };
      document.addEventListener('nc-looks:change', this.onLooks);
      // the header "Tu look" opens the page's look sheet / column instead of leaving for the cart page (when the page has one)
      this.link = this.closest('a');
      this.onLink = function (e) {
        var sheet = document.querySelector('nc-look-sheet');
        if (!sheet || typeof sheet.open !== 'function') return;
        e.preventDefault();
        sheet.open(self.link);
      };
      if (this.link) this.link.addEventListener('click', this.onLink);
      this.refresh();
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.bound = false;
      document.removeEventListener('nc-fitting:added', this.refresh);
      document.removeEventListener('nc-fitting:change', this.refresh);
      document.removeEventListener('nc-look:change', this.refresh);
      document.removeEventListener('nc-looks:change', this.onLooks);
      if (this.link) this.link.removeEventListener('click', this.onLink);
      window.removeEventListener('storage', this.refresh);
    }

    // progress of the look being created: a quiet pulse + a polite sentence (the contract has no percentage); "ready" lingers a few seconds
    setGenerating(n) {
      var state = badgeState(this.generating, n);
      this.generating = n;
      clearTimeout(this.readyTimer);
      this.setAttribute('data-state', state);
      var txt = this.querySelector('[data-look-text]');
      if (state === 'generating' && txt) txt.textContent = this.getAttribute('data-generating') || 'Creando tu look';
      else if (state === 'ready') {
        if (txt) txt.textContent = this.getAttribute('data-ready') || 'Look listo';
        var self = this;
        this.readyTimer = setTimeout(function () { self.setAttribute('data-state', 'idle'); self.refresh(); }, READY_MS);
      } else this.refresh();
    }

    gateway() {
      try { return window.NcApp && window.NcApp.gateway ? window.NcApp.gateway() : null; } catch (e) { return null; }
    }

    refresh() {
      var gw = this.gateway();
      if (!gw || typeof gw.getMyLook !== 'function') return;
      var self = this;
      gw.getMyLook().then(function (look) { self.render(look && typeof look.count === 'number' ? look.count : ((look && look.items) || []).length); }, function () { /* keep the last number */ });
    }

    render(n) {
      var num = this.querySelector('[data-look-count]');
      var txt = this.querySelector('[data-look-text]');
      if (num) num.textContent = n < 100 ? String(n) : '99+';
      if (txt) txt.textContent = fill(n === 1 ? this.getAttribute('data-one') : this.getAttribute('data-other'), n);
    }
  }

  customElements.define('nc-look-badge', NcLookBadge);
})();
